import {QUERY_KEYS} from '@/queryClient'
import {useQuery} from '@tanstack/react-query'
import {httpGetLanguages} from '@services/languages.http'

export const useGetLanguages = ({name = undefined}: {name?: string}) =>
    useQuery({
        queryKey: [QUERY_KEYS.LANGUAGES, name],
        queryFn: () => httpGetLanguages(name)
    })
